import { render, staticRenderFns } from "./PullRevenueCardInit.vue?vue&type=template&id=2cb74f2c&scoped=true&"
import script from "./PullRevenueCardInit.vue?vue&type=script&lang=js&"
export * from "./PullRevenueCardInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb74f2c",
  null
  
)

export default component.exports